export const localeEn = {
  gloabl: {
    name: "Name",
    details: "Details",
    selectMenu: "Select a menu",
    select: "select...",
    search: "Search...",
    new: "New",
    common: "Popular",
    recently: "Recently",
    unavailable: "Unavailable",
    connectUs: "Connect us ",
    branchInfo: "Branch information ",
    changeLang: "Change language ",
    isNotActive: "The resturant is not active ",
    options: "Options :",
    ProducedBy: "Powered by  ",
    totalPrice: "Total price",
    total: "Total",
    branches: "Branches",
    ourBranches: "Our Branches",
    welcome: "Welcome to ",
    getOfferNow: "Get Premium: Special Offer!",
    getUpTo:
      "Experience the full power of our digital menu platform with advanced features at an unbeatable price. Limited time offer! ",
    getOffer: "Get Offer",
    AED: "AED ",
    menus: "Menus",
    homepage: "Homepage",
    info: "Info",
    close: "اغلاق",
    AddToCart: "Add to Cart",
    Cart: "Cart",
    checkout: "Checkout",
    addNote: " Add Note",
    emptyCart: "Your cart is empty",
    emptyCartMessage:
      "It looks like you haven't added any item to your cart yet!",
    browseProducts: "Browse Products",
    orders: "Orders",
    ordersMessage: "You have no orders yet",
    noOrders: "No Orders",
    Settings: "Settings",
    theme: "Theme",
    verification: "A verification code has been sent to ",
    send: "Send",
    resend: "Resend",
    otp: "OTP",
    in: "in",
    s: "s",
    Invalid: "Invalid or expired OTP",
    orderSuccess: "Order Success, your order number is ",
    orderError: "There was an error with the request, please try again",
    addedToCart: "The product has been added to the cart.",
    clickToCart: "Click to go to cart",
    phoneOrName: "Please enter your phone number and name",
    phoneInvalid: "Please enter a valid phone number",
    order: "Order",
    orderDetails: "Order Details",
    value: "Value",
    Notes: "Notes",
    note: "Note",
    date: "Date",
    pending: "Pending",
    inProcess: "In Process",
    ready: "Ready",
    status: "Status",
    canselled: "Canceled",
    noNotes: "No notes",
    items: "Items",
    quantity: "Quantity",
    showAllOrders: "Show All Orders",
    noResult: "No Results",
    loading: "Loading...",
    CustomerName: "Customer Name",
    CustomerPhone: "Customer Phone",
    AllRightsReserved: "All Rights Reserved",
  },
  orderStatus: {
    pending: "Pending",
    processing: "Processing",
    completed: "Completed",
    canseled: "Cancelled",
    progress: "Processing",
    cancelled: "Cancelled",
  },
  //////////////////////////////////////////////////
  pages: {
    contact: "contact",
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    services: "Services",
    pricing: "Pricing",
    features: "Features",
    aboutUs: "About Us",
    home: "Home",
    notFound: "Not Found",
    deleteAccountGuide: "Delete account guide",
    getStarted: "Get Started",
    menu: "Menu",
  },
  deleteAccountGuide: {
    title: "How to delete your account",
    subtitle: "Follow these steps to delete your account from the app",
    step1Title: "Open the menu",
    step1Desc: "From the home screen, tap the menu icon (≡) at the top.",
    step2Title: "Select Delete account",
    step2Desc: "From the side menu, choose Delete account.",
    step3Title: "Confirm deletion",
    step3Desc: "Pick a reason then tap Delete to confirm.",
    noteTitle: "Note",
    noteText: "Account deletion is permanent and cannot be undone.",
  },
  HomePage: {
    // Hero Section
    heroTitle: "Kriech Restaurant",
    heroSubtitle: "Famous Syrian Fast Food Restaurant",
    heroDescription: "Made its way to Sharjah in 2012, and opened its second branch in Ajman in 2020. Our menu features delicious shawarma, burgers, and chicken sandwiches that are sure to satisfy any appetite.",
    browseMenu: "Browse Our Menu",
    orderNow: "Order Now",

    // About Section
    aboutTitle: "About Us",
    aboutDescription: "Kriech Restaurant is a famous Syrian fast food restaurant that made its way to Sharjah in 2012, and opened its second branch in Ajman in 2020. Our menu features delicious shawarma, burgers, and chicken sandwiches that are sure to satisfy any appetite. Visit us today to experience the authentic taste of Syrian cuisine.",

    // Branches Section
    branchesTitle: "Our Branches",
    branchesSubtitle: "Visit us at one of our branches",
    branchAddress: "Address",
    branchPhone: "Phone",
    branchMobile: "Mobile",
    branchWhatsapp: "WhatsApp",
    viewOnMap: "View on Map",
    workingHours: "Working Hours",
    dailyHours: "Daily from 11 AM to 1 AM",

    // Features Section
    featuresTitle: "Why Choose Kriech?",
    freshFood: "Fresh Food",
    freshFoodDesc: "We use the finest fresh ingredients in all our dishes",
    authenticTaste: "Authentic Taste",
    authenticTasteDesc: "We offer the authentic taste of Syrian cuisine",
    fastService: "Fast Service",
    fastServiceDesc: "We ensure fast and efficient delivery of your order",

    // App Download Section
    appDownloadTitle: "Download Our App Now",
    appDownloadSubtitle: "Order your favorite food easily through our app",
    appDownloadDescription: "Enjoy a fast and easy ordering experience. Order from anywhere, anytime, and get exclusive offers!",
    downloadNow: "Download Now",
    availableOn: "Available on",

  },

  contact: {
    sendMessage: "Send Message",
    name: "Name",
    email: "Email",
    subject: "Subject",
    message: "Message",
    send: "Send",
    phone: "Phone",
    sendMassageParagraph:
      "We'd love to hear from you! Please fill out the form below.",
    ReachOutDirectly: "Reach Out Directly",
    ConnectWithUs: "Connect With Us",
  },
  footer: {
    allRightsReserved: "All Rights Reserved",
    qickLinks: "Quick Links",
    contactUs: "Contact Us",
  },
  /////////////////////////////////
  PrivacyPolicy: {
    title: "Privacy Policy",

  },
  ////////////////////////// END PRIVACY POLICY ///////////////////////////

  //////////////////////////////////////////////////////////////
  Terms: {
    title: `Terms of Service`,
  },
  order: {
    success: {
      title: "Your Order Has Been Received Successfully!",
      message: "Thank you! Your order has been received and will be processed soon",
      orderNumber: "Order Number",
      estimatedTime: "Estimated Delivery Time",
      backToHome: "Back to Home",
    },
    failed: {
      title: "Order Processing Failed",
      message: "Sorry, an error occurred while processing your order. Please try again",
      reason: "Reason",
      tryAgain: "Try Again",
      backToHome: "Back to Home",
    },
  },
  notFound: {
    title: "404",
    heading: "Page Not Found",
    message: "Sorry, the page you are looking for does not exist",
    backToHome: "Back to Home",
  },
};
